import { createRenderer } from '@web-config-app/entity-form';
import { isArrayObjectReferenceInjectControl } from '../testers/testers';
import { MasonryArrayOfObjectWithDatasourceControl } from '../components/masonry-array-of-object-with-datasource-control/masonry-array-of-object-with-datasource-control';

export const arrayPrimitiveObjectWithReferenceInjectControlRenderer =
  createRenderer(
    isArrayObjectReferenceInjectControl,
    MasonryArrayOfObjectWithDatasourceControl,
    'array',
  );

export const nodesRenderers = [
  arrayPrimitiveObjectWithReferenceInjectControlRenderer,
];
